import React from "react";
import { Row } from "reactstrap";
import { H5, P } from "../../../AbstractElements";
import {
  TaskHeadings1,
  TaskHeadings2,
  TaskHeadings3,
} from "../../../Data/Driver/CarContent";
import moment from "moment";
const CarContent = ({ carObj }) => {
  const Table3Data = TaskHeadings3.map((element, i) => {
    let value = carObj[element.value] ? carObj[element.value] : '-'
    if ((element.value == 'createdOn' || element.value == 'deletedOn' || element.value == 'updatedOn') && value !== '-') {
      console.log(value, 'value');
      value = moment(value).format('MMM DD,YYYY')
    }
    if (element.value == 'ratingAvg') {
      console.log(value, 'value');
      value = carObj[element.value]
    }
    if ((element.value == "blockedReason" || element.value == "blockedBy") && carObj["isAvailable"]) {
      return;
    }
    return (
      <tr key={i}>
        <td>
          <P>{element.name}</P>
        </td>
        <td>
          <P>{value}</P>
        </td>
      </tr>
    );
  })
  return (
    <Row>
      <div className="table-responsive">
        <table className="driver-list-table">
          <thead>
            <tr></tr>
          </thead>
          <tbody>
            {TaskHeadings1.map((element, i) => {
              return (
                <tr key={i}>
                  <td>
                    <P>{element.name}</P>
                  </td>
                  <td>
                    <P>{carObj[element.value] ? carObj[element.value] : '-'}</P>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="table-responsive">
        <table className="driver-list-table">
          <thead>
            <tr></tr>
          </thead>
          <tbody>
            {TaskHeadings2.map((element, i) => {
              let value = carObj[element.value] ? carObj[element.value] : '-'
              if ((element.value == 'createdOn' || element.value == 'deletedOn' || element.value == 'updatedOn') && value !== '-') {
                console.log(value, 'value');
                value = moment(value).format('MMM DD,YYYY')
              }
              return (
                <tr key={i}>
                  <td>
                    <P>{element.name}</P>
                  </td>
                  <td>
                    <P>{value}</P>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="table-responsive" style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between"
      }}>
        <table className="driver-list-table">
          <thead>
            <tr></tr>
          </thead>
          <tbody>
            {Table3Data}
          </tbody>
        </table>
        {carObj.isEv ? <div style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          backgroundColor: "white",
          borderRadius: "10px"
        }}>
          <span style={{
            color: "rgba(82,82,108,.8)",
            margin: "5px 0px"
          }}>EV Battery Level</span>
          <H5>{carObj.batteryPercentage ? carObj.batteryPercentage : "-"}</H5>
        </div> : null}
      </div>
    </Row>
  );
};

export default CarContent;
